import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Select from 'react-select';
import Sidebar from '../components/Sidebar';
import axios from 'axios';
import { useCustomSnackbar } from '../hooks/useCustomSneakbar';
import moment from 'moment';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { useNavigate } from 'react-router-dom';
import { ErrorMessage } from '../validation/validationError';
import { ZodError } from 'zod';
import { appVersionUpdateFormValidation } from '../validation/Validation';
import { Loader } from '../components/ModalsCommonFunctions';

const AppVersionUpdate = () => {
    const authorizedAxios = generateAxiosInstance()
    const initialFormState = {
        version_name: '',
        version_code: ''
    }
    const [appData, setAppData] = useState(initialFormState)
    const [appVersion, setAppVersion] = useState({})
    const [editId, setEditId] = useState(null)
    const [errors, setErrors] = useState([]);

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getAppVersion();
    }, []);

    const getAppVersion = () => {
        const apiUrlForSyllabus = `/get-app-version`;
        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setAppVersion(response.data.data)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.log("Error data fetching: ", errorMsg);
            });
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setAppData((prevData) => {
            return {
                ...prevData,
                [name]: value
            }
        })

        if (value.trim().length !== 0) {
            setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    }

    const createNewVersion = async () => {
        try {
            await appVersionUpdateFormValidation.parseAsync(appData);
            setErrors([]);
            setLoading(true);
    
            const apiUrl = `/upgrade-app-version`;
            if (authorizedAxios) {
                const response = await authorizedAxios.post(apiUrl, appData);
                setAppData(initialFormState);
                getAppVersion();
                Swal.fire({ text: response.data.message });
            }
        } catch (err) {
            if (err instanceof ZodError) {
                setErrors(err.errors);
            } else {
                const errorMsg = err?.response?.data?.message || 'Something went wrong!';
                Swal.fire({ text: errorMsg });
            }
        } finally {
            setLoading(false);
        }
    };

    const handleInputReset = () => {
        setEditId('');
        setAppData(initialFormState);
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>App Version Update</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fas fa-arrow-circle-up"></i>App Version Update</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="col-md-6">
                                                    <label for="version_name" className="col-form-label"><span style={{ color: "red" }}>*</span>Enter Version Name :</label>
                                                    <input required type="text" id='version_name' className="form-control" name="version_name" value={appData.version_name} onChange={handleInputChange} />

                                                    <ErrorMessage errors={errors} field="version_name" />
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="version_code" className="col-form-label"><span style={{ color: "red" }}>*</span>Enter Version Code :</label>
                                                    <input required type="text" id='version_code' className="form-control" name="version_code" value={appData.version_code} onChange={handleInputChange} />

                                                    <ErrorMessage errors={errors} field="version_code" />
                                                </div>

                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>

                                                    <div className="col-auto">
                                                        {!editId &&
                                                            <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={createNewVersion}>Save</button>
                                                        }
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={handleInputReset}>Reset</button>
                                                        {/* {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateUser} disabled={!editId}>Update</button>)
                                                        } */}
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width ">
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">Version Name</th>
                                                                        <th scope="col">Version Code</th>
                                                                        <th scope="col">Modified By (User Id)</th>
                                                                        <th scope="col">Modified Date</th>
                                                                        <th scope="col">Previous Version Code</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        appVersion && Object.keys(appVersion).length > 0 ? (
                                                                            <tr>
                                                                                <th scope="row" className='sl_no'>1</th>
                                                                                <td>{appVersion.versionName}</td>
                                                                                <td>{appVersion.versionCode}</td>
                                                                                <td>{appVersion.modifiedBy}</td>
                                                                                <td>{appVersion.modifiedDate?.split("T")[0]} &nbsp; {new Date(appVersion.modifiedDate).toISOString().split('T')[1].split('.')[0]}</td>
                                                                                <td>{appVersion.previousVersionCode}</td>
                                                                            </tr>
                                                                        ) : (
                                                                            <tr>
                                                                                <th colSpan="100%" style={{ textAlign: 'center', padding: "50px" }}>
                                                                                    No App Version Available
                                                                                </th>
                                                                            </tr>
                                                                        )
                                                                    }

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default AppVersionUpdate;